<template lang="pug">
    header(:class="{'-active':show}")
        a.link(href="#")
            img(src="../assets/img/main-logo.svg")
</template>
<style lang="scss" scoped>
header {
    position: fixed;
    z-index: 30;
    width: 100%;
    padding-top: 16px;
    padding-bottom: 12px;
    display: flex;
    transform: translateY(-100%);
    transition: 0.5s;
    justify-content: center;
    background: #fff;

    &.-active {
        transform: translateY(0%);
    }

    @media #{$pc} {
        display: none;
    }

    > .link > img {
        height: 32px;
    }
}
</style>
<script>
export default {
    data() {
        return {
            scroll: 0,
            windowHeight: 0,
            show: false
        };
    },
    mounted() {
        document.addEventListener("scroll", this.scrollSet);
    },
    methods: {
        scrollSet() {
            this.scroll = window.pageYOffset;
            this.windowHeight = window.innerHeight;
        }
    },
    watch: {
        scroll() {
            if (this.scroll > this.windowHeight) {
                this.show = true;
            } else {
                this.show = false;
            }
        }
    }
};
</script>
